import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const SiteFooter: React.FC = () => {
  const navigate = useNavigate();

  return <Box
    component="footer"
    sx={{
      width: '100%',
      backgroundColor: '#fdf3e4',
      borderTop: '1px solid #ead7be',
      color: '#6d5549',
      py: 2,
      px: 2,
      textAlign: 'center',
      position: 'relative',
      zIndex: 3,
    }}
  >
    <Link
      component={RouterLink}
      to="/terms-of-use"
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        navigate('/terms-of-use');
      }}
      sx={{ color: '#7b0011', fontWeight: 800, textDecoration: 'none', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
    >
      Terms of Use and Policies
    </Link>
    <Typography variant="body2" sx={{ mt: 1 }}>
      © {new Date().getFullYear()} Maandvo Matrimony Service. All Rights Reserved
    </Typography>
    <Typography variant="body2">Managed by TechwithT</Typography>
  </Box>;
};

export default SiteFooter;
